import { AppShell } from '@mantine/core';
import { createPlayerRegistry } from 'entities/player';
import { playersPageModel } from '../../model';
import cls from './players-page.module.scss';

const PlayerRegistry = createPlayerRegistry(playersPageModel.playerRegistryModel);

export const PlayersPage = () => (
	<AppShell.Main className={cls.playersPage}>
		<PlayerRegistry className={cls.playersPageRegistry} />
	</AppShell.Main>
);
